import { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody, ModalFooter } from "reactstrap";

const initialState = {
    name: "",
    amount: "",
    transaction_id: "",
};

function Pingpong({ isOpen, onClose, onSubmit, title }) {
    const [formData, setFormData] = useState(initialState);
    // Ảnh chỉ bắt chọn để xác nhận có biên lai thật — không upload, không gửi lên server
    const [screenshot, setScreenshot] = useState(null);
    const { t } = useTranslation();

    const handleChangeForm = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const canSubmit = formData.name.trim() && Number(formData.amount) > 0 && formData.transaction_id.trim().length >= 6 && !!screenshot;

    const handleSubmit = () => {
        if (!canSubmit) return;
        onClose();
        setFormData(initialState);
        setScreenshot(null);
        onSubmit?.(formData);
    };

    return (
        <Fragment>
            <Modal centered={true} size="lg" toggle={onClose} isOpen={isOpen} scrollable={true}>
                <div className="modal-header">
                    <h1 className="mb-0">{title || t("Modal App")}</h1>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
                        <i className="ki-outline ki-cross fs-1" onClick={onClose}></i>
                    </div>
                </div>
                <ModalBody>
                    <div class="notice bg-light-primary rounded border-primary border border-dashed mb-9 p-6">
                        <div className="d-flex mb-3" style={{ height: '40px' }}>
                            <img src="https://dash.burgerprints.com/assets/img/PingPongLogo.svg" alt="PingPong" />
                        </div>
                        <div class="d-flex flex-stack flex-grow-1">
                            <div class="fw-bold">
                                <div>
                                    <span class="fs-6 text-blue-800">{t("Transfer")}: COTIK - payment@cotik.app (LE BACH HOANG AN)</span>
                                    <button className="btn btn-link text-hover-primary p-0 ms-1" data-tooltip-id="my-tooltip" data-tooltip-content={"Copy"} onClick={() => navigator.clipboard.writeText("payment@cotik.app")} style={{ verticalAlign: "inherit" }}>
                                        <i className="ki-duotone ki-copy"></i>
                                    </button>
                                </div>
                                <div class="fs-6 text-blue-600">
                                    {t("After transferring, enter your PingPong account name and the exact amount. The system will verify the transaction and top up automatically.")}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                            <span className="required">{t("PingPong Account Name")}</span>
                        </label>
                        <input
                            type="text"
                            className="form-control form-control-solid"
                            value={formData?.name || ""}
                            placeholder={t("Name shown on your PingPong account")}
                            name="name"
                            onChange={handleChangeForm}
                        />
                    </div>
                    <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                            <span className="required">{t("Transaction ID")}</span>
                        </label>
                        <input
                            type="text"
                            className="form-control form-control-solid"
                            value={formData?.transaction_id || ""}
                            placeholder={t("Transaction ID on your PingPong receipt")}
                            name="transaction_id"
                            onChange={handleChangeForm}
                        />
                    </div>
                    <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                            <span className="required">{t("Amount")} (USD)</span>
                        </label>
                        <input
                            type="number"
                            min="0"
                            step="0.01"
                            className="form-control form-control-solid"
                            value={formData?.amount || ""}
                            placeholder={t("Exact amount transferred, e.g. 50.00")}
                            name="amount"
                            onChange={handleChangeForm}
                        />
                    </div>
                    <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                            <span className="required">{t("Transaction Screenshot")}</span>
                        </label>
                        <input
                            key={String(isOpen)}
                            type="file"
                            accept="image/*"
                            className="form-control form-control-solid"
                            onChange={(e) => setScreenshot(e.target.files?.[0] || null)}
                        />
                        {!screenshot && (
                            <div className="fs-7 text-danger mt-1">{t("Please attach a screenshot of your transaction!")}</div>
                        )}
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button
                        type="reset"
                        id="kt_modal_users_search_reset"
                        data-bs-dismiss="modal"
                        className="btn btn-active-light me-3"
                        onClick={onClose}
                    >
                        {t("Cancel")}
                    </button>
                    <button
                        type="submit"
                        id="kt_modal_users_search_submit"
                        className="btn btn-primary"
                        disabled={!canSubmit}
                        onClick={() => {
                            handleSubmit();
                        }}
                    >
                        {t("Process Topup")}
                    </button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
}

export default Pingpong;
